"use client";

import getPriceInfoFromProduct, {
  PriceType,
} from "@/utils/elevate/getPriceInfoFromProduct";
import { useMarket } from "@app/_context";
import useTranslate from "@app/_hooks/useTranslate";
import type { CustomProduct } from "@apptus/esales-api";
import Price from "../price/Price";
export default function ProductCardPrice({
  product,
}: {
  product: CustomProduct;
}) {
  const t = useTranslate();
  const { market } = useMarket().state;
  const price = getPriceInfoFromProduct(product, market);

  return (
    <div className="flex flex-row flex-wrap gap-x-1">
      <Price
        prefix={price.fromPrice ? t("fromShortened") : undefined}
        price={price.price}
      />
      {(price.priceType === PriceType.campaign ||
        price.priceType === PriceType.pricematch) && (
        <Price
          className="text-gray-500 line-through"
          price={price.priceRrp ?? price.price}
        />
      )}
    </div>
  );
}

ProductCardPrice.displayName = "ProductCardPrice";
